module.exports = __webpack_public_path__ + "static/media/downtimedollars-logo-loading.ce3e1e25.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/downtimedollars-logo-loading.png
// module id = 350
// module chunks = 0